import _ from 'lodash';
import { get } from '@/helpers';

import trim from 'lodash.trim';
import Vue from 'vue';
import SetupApi from '@/store/api/setup';
import FormApi from '@/store/api/form';

import CategoryPost from '@/views/CategoryPost';

import { default as router, resetRouter } from '@/router';

import { removeKeys } from '@/helpers/util';

// initial state
// shape: [{ id, quantity }]
const state = {
    loaded: false,
    ready: false,
    error: false,
    CMS: {},
    // config: {},
    messages: [],
    ui: {
        sidebar: false, // sidebar visibility
    },
    uploadEndpoint: trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_UPLOAD_ROUTE}`, '/'),
};

// getters
const getters = {
    // auth: state => state.auth,
    loaded: (state) => state.loaded,
    ready: (state) => state.ready,
    error: (state) => state.error,
    CMS: (state) => state.CMS,
    config: (state) => state.CMS.config,
    menus: (state) => state.CMS.menus,
    messages: (state) => state.messages,
    sidebar: (state) => state.ui.sidebar,

    logo: (state) => {
        let logo = {};
        if (state.CMS.images && state.CMS.images.length > 0) {
            logo = state.CMS.images.find((image) => image.type === 'cms-logo');
        }
        return logo;
    },
    googleRecaptchaSiteKey: (state) => {
        const apiKeys = _.get(state.CMS, 'apiKeys') || [];
        const apiKey = apiKeys.find((apiKey) => apiKey.key === 'google-recaptcha-v3');

        let googleRecaptchaSiteKey;
        if (apiKey) googleRecaptchaSiteKey = apiKey.public;
        return googleRecaptchaSiteKey;
    },
    mapBoxToken: (state) => {
        const apiKeys = _.get(state.CMS, 'apiKeys') || [];
        const apiKey = apiKeys.find((apiKey) => apiKey.key === 'mapbox');

        let token;
        if (apiKey) token = apiKey.public;
        return token;
    },
};

// actions
const actions = {
    fetchSetup({ commit }, { base_url }) {
        return SetupApi.fetchSetup(base_url)
            .then((setup) => {
                if (setup) {
                    commit('addSetupToState', setup);
                    commit('mapRouter');
                } else {
                    // throw new Error('There is no content for this domain.')
                    commit('setError', { code: 404, message: 'Not Found!' });
                }
            })
            .catch((error) => commit('fetchFailed', error));
    },
    // pageReady({ commit, state }) {
    //     commit('isReady', true)
    // },
    // pageNotReady({ commit, state }){
    //     commit('isReady', false)
    // },
    sendFormToApi({ commit }, payload) {
        const success_message = {
            id: _.uniqueId(),
            title: 'Erfolgreich',
            text: 'Ihre Nachricht wurde erfolgreich versendet.',
            type: 'success',
            autoclose: 5000,
        };
        const error_message = {
            id: _.uniqueId(),
            title: 'Fehler',
            text: 'Ihre Nachricht konnte nicht versendet werden.',
            type: 'danger',
            autoclose: 5000,
        };
        removeKeys(payload, ['__typename']);
        return FormApi.create(payload)
            .then((data) => commit('addMessage', success_message))
            .catch((error) => commit('addMessage', error_message));
    },
};

// mutations
const mutations = {
    addSetupToState(state, cms) {
        state.loaded = true;
        // state.meta = data.setup.meta
        state.CMS = cms;
        // state.config = data.config
    },
    isReady(state, value) {
        if (value === true) state.loaded = true;

        state.ready = value;
    },
    updateSidebarVisibility(state, value) {
        state.ui.sidebar = value;
    },
    mapRouter(state) {
        let loadingRoutes = [];

        const staticRoutes = [
            {
                path: '/aktuelles/:key',
                name: 'Aktuelles',
                component: CategoryPost,
                meta: {
                    icon: null,
                    title: 'Aktuelles',
                    category: {
                        key: 'news',
                    },
                },
            },
            {
                path: '/homepage/:key',
                name: 'Homepage',
                component: CategoryPost,
                meta: {
                    icon: null,
                    title: 'Homepage',
                    category: {
                        key: 'homepage',
                    },
                },
            },
            {
                path: '/mitglieder/:key',
                name: 'Mitglieder',
                component: CategoryPost,
                meta: {
                    icon: null,
                    title: 'Mitglieder',
                    category: {
                        key: 'mitglieder',
                    },
                },
            },
            {
                path: '/archiv/:key',
                name: 'Archiv',
                component: CategoryPost,
                meta: {
                    icon: null,
                    title: 'Archiv',
                    category: {
                        key: 'archiv',
                    },
                },
            },
            {
                path: '/infomitglieder/:key',
                name: 'Infos unserer Mitglieder',
                component: CategoryPost,
                meta: {
                    icon: null,
                    title: 'Infos unserer Mitglieder',
                    category: {
                        key: 'infomitglieder',
                    },
                },
            },
            {
                path: '/blog/:key/:src?',
                name: 'blog',
                // component: () => import('@/views/CategoryPost.vue'),
                meta: {
                    icon: null,
                    title: state.CMS.name ? `${state.CMS.name} - Blog` : 'Blog',
                    category: {
                        key: 'blog'
                    }
                }
            },
            {
                path: '*',
                name: 'Page Not Found',
                component: () => import('@/views/PageNotFound.vue'),
                meta: {
                    icon: null,
                    title: 'Page Not Found',
                    skipMiddleware: true,
                },
            },
            // add static category routes
        ];

        if (state.CMS.menus && state.CMS.menus.length) {
            const nodeRoutes = (data) => {
                let routes = [],
                    items = data.items;
                _.each(items, (item, index) => {
                    if (item.disabled) return true;

                    let children = null;
                    if (item.children) {
                        children = nodeRoutes({ items: item.children });
                    }

                    let component, view;
                    if (item.page && item.page.view) {
                        component = () => import(`@/views/${item.page.view}.vue`);
                        view = item.page.view;
                    }
                    const meta = {
                        rootIndex: index,
                        icon: item.icon,
                        title: state.CMS.name ? `${state.CMS.name} - ${item.title}` : item.title,
                        pageID: get(item.page, 'id'),
                        menuItemID: item.id,
                    };
                    switch (view) {
                        case 'Redirect':
                            const type = _.get(item.page, 'hyperlink.type');
                            const redirect = _.get(item.page, 'hyperlink.menuItem.path');
                            if (type === 'internal' && redirect) {
                                const node = {
                                    name: item.title || '',
                                    path: item.path,
                                    redirect,
                                    meta
                                };
                                routes.push(node);
                            }
                            break;

                        default:
                            const node = {
                                name: item.title || '',
                                path: item.path,
                                component,
                                meta,
                                children: children,
                            };
                            routes.push(node);
                    }
                });
                return routes;
            };

            let dynamicRoutes = [];
            state.CMS.menus.forEach((menu) => {
                nodeRoutes({ items: menu.menuItems }).forEach((item) => dynamicRoutes.push(item));
            });

            _.each(dynamicRoutes, (route) => {
                loadingRoutes.push(route);
            });
        }

        _.each(staticRoutes, (route) => {
            loadingRoutes.push(route);
        });

        resetRouter();
        router.addRoutes(loadingRoutes);
    },
    fetchFailed(state, error) {
        /* eslint no-console: ["error", { allow: ["error"] }] */
        console.error(error);
    },
    setError(state, error) {
        state.error = error;
    },
    addMessage(state, message) {
        const messages = _.get(state, 'messages', []);
        const i = messages.length;

        const search = _.pick(message, ['title', 'text', 'info', 'type']);
        const existing = _.findIndex(messages, search);
        if (existing >= 0) {
            Vue.set(state.messages[existing], 'autoclose', _.get(message, 'autoclose'));
            Vue.set(state.messages[existing], 'highlight', true);
            setTimeout(() => {
                if (_.has(state.messages[existing], 'highlight')) Vue.set(state.messages[existing], 'highlight', false);
            }, 200);
        } else {
            Vue.set(state.messages, i, message);
        }
    },

    removeMessage(state, id) {
        const message = _.find(state.messages, { id });
        const i = _.findIndex(state.messages, message);

        if (i !== -1) {
            Vue.delete(state.messages, i);
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
